import { createApp } from 'vue'
import $bus from '@/common/event.js'
import App from './App.vue'
// import '@/registerServiceWorker'
import router from './router'
import make_store from '@/pages/home/store'
import { setupI18n, setI18nLanguage } from './i18n.js'
import { applySeo } from './seo.js'
import {
    getPublicPath,
    isTapgiantPublicDomain,
    PUBLIC_DOMAIN_LOCALE
} from './public-routes.js'
import en from '@/locale/console/en.json'

import 'bootstrap/js/dist/button'
import 'bootstrap/js/dist/tab'
import 'bootstrap/js/dist/carousel'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/collapse'
import modal from '@/common/modal/modal.vue'
import { SENTRY_DSN_CONSOLE } from '@/common/constants.js'

import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

import ParseUserAgent from '@/common/filter/ParseUserAgent.js'
import PrettyDate from '@/common/filter/PrettyDate.js'
import NumberShortener from '@/common/filter/NumberShortener.js'
import NumberFormatter from '@/common/filter/NumberFormatter.js'
import DateToMinutes from '@/common/filter/DateToMinutes.js'
import TimeAgo from '@/common/filter/TimeAgo.js'

const store = make_store($bus)
const app = createApp(App)

app.component('Modal', modal)

app.config.globalProperties.$bus = $bus
app.config.globalProperties.$filters = {
    PrettyDate,
    ParseUserAgent,
    NumberShortener,
    NumberFormatter,
    DateToMinutes,
    TimeAgo
}

const i18n = setupI18n({
    globalInjection: true,
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en
    }
})

$bus.$on('App/locale', async function (locale) {
    await setI18nLanguage(i18n, locale)
    store.commit('SET_LOCALE', locale)
    applySeo(router.currentRoute.value, locale)
})

const localeReady = store.state.locale !== 'en'
    ? setI18nLanguage(i18n, store.state.locale)
    : Promise.resolve()

router.afterEach(async function (to) {
    const isPublicRoute = Boolean(getPublicPath(to.name, PUBLIC_DOMAIN_LOCALE))

    if (isPublicRoute && isTapgiantPublicDomain() && store.state.locale !== PUBLIC_DOMAIN_LOCALE) {
        await setI18nLanguage(i18n, PUBLIC_DOMAIN_LOCALE)
        store.commit('SET_LOCALE', PUBLIC_DOMAIN_LOCALE)
    }

    applySeo(to, store.state.locale)
})

if (import.meta.env.PROD) {
    Sentry.init({
        Vue: app,
        dsn: SENTRY_DSN_CONSOLE,
        integrations: [new Integrations.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ['localhost', 'tapgiant.com', 'tapgiant.ro', /^\//]
        })],
        disablePerformance: true
    })
}

localeReady.then(function () {
    app.use(store)
        .use(router)
        .use(i18n)
        .mount('#app')
})
